
import React from 'react';
export const SBATextBox = (value) => {
    if ((value.trim()).length === 0) {
        return false
    }
    else {
        return true
    }
}